/* ================================================
   HITCH — Cart Drawer JS
   Opens drawer, renders cart, handles qty changes,
   free-ship bar, upsell recommendations.
   Globally available: window.HitchCartDrawer.open()
   ================================================ */
(function(){
  'use strict';

  var THRESHOLD = 4000; // free-shipping threshold in cents ($40)
  var moneyFmt = null;  // set on first use

  /* ── Money formatter ── */
  function formatMoney(cents){
    try{
      if(window.Shopify && typeof Shopify.formatMoney === 'function'){
        return Shopify.formatMoney(cents, moneyFmt);
      }
    }catch(e){}
    var n = (Number(cents)||0) / 100;
    try{ return n.toLocaleString(undefined,{style:'currency',currency:'USD'}); }catch(e){ return '$'+n.toFixed(2); }
  }

  /* ── DOM refs ── */
  var overlay   = document.getElementById('CartDrawerOverlay');
  var closeBtn  = document.getElementById('CartDrawerClose');
  var contBtn   = document.getElementById('CDContinue');
  var itemsWrap = document.getElementById('CDItems');
  var subtotalEl= document.getElementById('CDSubtotal');
  var shipEstEl = document.getElementById('CDShippingCost');
  var estTotalEl= document.getElementById('CDEstTotalAmt');
  var checkoutEl= document.getElementById('CDCheckout');
  var fsMeter   = document.getElementById('CDFreeShipMeter');
  var fsMsg     = document.getElementById('CDFreeShipMsg');
  var fsBar     = document.getElementById('CDFreeShip');
  var upsellWrap= document.getElementById('CDUpsells');
  var upsellGrid= document.getElementById('CDUpsellGrid');

  if(!overlay) return; // safety

  /* ── Open / Close ── */
  function open(){
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
    refresh();
  }
  function close(){
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', close);
  contBtn.addEventListener('click', close);
  overlay.addEventListener('click', function(e){
    if(e.target === overlay) close();
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && overlay.classList.contains('is-open')) close();
  });

  /* ── Debounced refresh — prevents spamming /cart.js ── */
  var refreshTimer = null;
  var refreshInFlight = false;
  function refresh(){
    if(refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(doRefresh, 150);
  }
  function doRefresh(){
    if(refreshInFlight) return;
    refreshInFlight = true;
    fetch('/cart.js',{credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(cart){ render(cart); })
      .catch(function(){})
      .then(function(){ refreshInFlight = false; });
  }

  function broadcastCart(cart){
    try{ window.__cart = cart; }catch(e){}
    try{ document.dispatchEvent(new CustomEvent('cart:updated',{detail:cart})); }catch(e){}
  }

  function render(cart){
    broadcastCart(cart);

    // Update header count
    var countEls = document.querySelectorAll('.hh-cart-count');
    countEls.forEach(function(el){ el.textContent = cart.item_count; });

    // Empty state — handle before updating prices so we don't show $6.90 on an empty cart
    if(cart.item_count === 0){
      itemsWrap.innerHTML = '<div class="cd-empty"><div class="cd-empty__icon">\uD83D\uDECD\uFE0F</div><p class="cd-empty__text">Your cart is empty</p><a href="/#shop-by-moment" class="cd-btn cd-btn--primary cd-empty__cta">Shop by Moment</a></div>';
      if(upsellWrap) upsellWrap.hidden = true;
      // Hide footer pricing and disable checkout
      var shipRow = document.getElementById('CDShippingEstimate');
      var totalRow = document.getElementById('CDEstTotal');
      if(shipRow) shipRow.style.display = 'none';
      if(totalRow) totalRow.style.display = 'none';
      subtotalEl.textContent = formatMoney(0);
      if(checkoutEl){ checkoutEl.style.pointerEvents = 'none'; checkoutEl.style.opacity = '.4'; }
      if(fsBar) fsBar.style.display = 'none';
      return;
    }

    // Restore footer elements (in case previously hidden by empty state)
    var shipRow = document.getElementById('CDShippingEstimate');
    var totalRow = document.getElementById('CDEstTotal');
    if(shipRow) shipRow.style.display = '';
    if(totalRow) totalRow.style.display = '';
    if(checkoutEl){ checkoutEl.style.pointerEvents = ''; checkoutEl.style.opacity = ''; }
    if(fsBar) fsBar.style.display = '';

    // Subtotal
    subtotalEl.textContent = formatMoney(cart.total_price);

    // Shipping estimate (updates live as cart changes)
    var shipCents = 690; // $6.90 flat rate
    var isFreeShip = cart.total_price >= THRESHOLD;
    if(shipEstEl){
      if(isFreeShip){
        shipEstEl.textContent = 'FREE';
        shipEstEl.style.color = '#16a34a';
        shipEstEl.style.fontWeight = '800';
      } else {
        shipEstEl.textContent = '$6.90';
        shipEstEl.style.color = '';
        shipEstEl.style.fontWeight = '';
      }
    }
    // Estimated total (subtotal + shipping)
    if(estTotalEl){
      var totalWithShip = isFreeShip ? cart.total_price : cart.total_price + shipCents;
      estTotalEl.textContent = formatMoney(totalWithShip);
    }

    // Free-ship bar
    updateFreeShip(cart.total_price);

    // Render items
    var html = '';
    cart.items.forEach(function(item){
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/,'_180x$1$2') : '';
      var variant = item.variant_title || '';
      // Determine the max qty allowed: inventory_quantity when policy is 'deny', otherwise unlimited (999)
      var inventoryPolicy = item.variant_inventory_policy || item.inventory_policy || 'continue';
      var inventoryQty = (typeof item.variant_inventory_quantity !== 'undefined') ? item.variant_inventory_quantity : 999;
      var maxQty = (inventoryPolicy === 'deny' && inventoryQty > 0) ? inventoryQty : 999;
      var atMax = item.quantity >= maxQty;
      html += '<div class="cd-item" data-key="'+item.key+'" data-max="'+maxQty+'">';
      html += '  <div class="cd-item__img">'+(img ? '<img src="'+img+'" alt="" loading="lazy">' : '')+'</div>';
      html += '  <div class="cd-item__info">';
      html += '    <a class="cd-item__title" href="'+item.url+'">'+item.product_title+'</a>';
      if(variant) html += '    <div class="cd-item__variant">'+variant+'</div>';
      if(atMax) html += '    <div class="cd-item__max-msg">Max qty reached</div>';
      html += '    <div class="cd-item__bottom">';
      html += '      <div class="cd-item__qty">';
      html += '        <button type="button" data-action="minus" aria-label="Decrease quantity">−</button>';
      html += '        <span>'+item.quantity+'</span>';
      html += '        <button type="button" data-action="plus" aria-label="Increase quantity"'+(atMax ? ' disabled aria-disabled="true"' : '')+'>+</button>';
      html += '      </div>';
      html += '      <div class="cd-item__price">'+formatMoney(item.final_line_price)+'</div>';
      html += '    </div>';
      html += '    <button type="button" class="cd-item__remove" data-action="remove">Remove</button>';
      html += '  </div>';
      html += '</div>';
    });
    itemsWrap.innerHTML = html;

    // Bind qty buttons
    itemsWrap.querySelectorAll('[data-action]').forEach(function(btn){
      btn.addEventListener('click', function(){
        if(btn.disabled) return;
        var row = btn.closest('.cd-item');
        var key = row.getAttribute('data-key');
        var maxQty = parseInt(row.getAttribute('data-max')) || 999;
        var qtySpan = row.querySelector('.cd-item__qty span');
        var qty = parseInt(qtySpan.textContent)||1;
        var action = btn.getAttribute('data-action');
        var newQty = action === 'plus' ? Math.min(qty + 1, maxQty) : action === 'minus' ? Math.max(0, qty - 1) : 0;
        if(newQty === qty && action !== 'remove') return; // already at limit, no-op
        updateQty(key, newQty);
      });
    });

    // Upsells (load if product page has a product id)
    loadUpsells(cart);
  }

  /* ── Update quantity ── */
  function updateQty(key, qty){
    fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:key, quantity:qty})
    })
    .then(function(r){
      if(!r.ok){
        // Shopify rejected (e.g. 422 inventory exceeded) — re-fetch real cart state
        return fetch('/cart.js',{credentials:'same-origin'}).then(function(r2){ return r2.json(); });
      }
      return r.json();
    })
    .then(function(cart){
      // Guard: if Shopify returned an error object instead of a cart, re-fetch
      if(!cart || typeof cart.total_price === 'undefined'){
        return fetch('/cart.js',{credentials:'same-origin'})
          .then(function(r){ return r.json(); })
          .then(function(realCart){ render(realCart); });
      }
      render(cart);
    })
    .catch(function(){
      // On any network error, re-fetch to stay in sync
      fetch('/cart.js',{credentials:'same-origin'})
        .then(function(r){ return r.json(); })
        .then(function(cart){ render(cart); })
        .catch(function(){});
    });
  }

  /* ── Free-ship bar ── */
  function updateFreeShip(totalCents){
    var pct = Math.min(100, Math.round((totalCents / THRESHOLD)*100));
    if(fsMeter) fsMeter.style.width = pct + '%';
    var remaining = THRESHOLD - totalCents;
    if(remaining > 0){
      fsMsg.innerHTML = 'Add <strong>'+formatMoney(remaining)+'</strong> more to unlock <strong>free shipping</strong>. <span style="font-size:.78rem;font-weight:400;opacity:.85">Free shipping over $40.</span>';
      fsBar.classList.remove('cd-freeship--unlocked');
    } else {
      fsMsg.innerHTML = '<strong>Free shipping unlocked!</strong>';
      fsBar.classList.add('cd-freeship--unlocked');
    }
  }

  /* ── Upsell recommendations ── */
  var lastUpsellKey = null;    // fingerprint to avoid needless re-fetches
  var upsellInFlight = false;
  var completeLookCache = {};

  function productHandleFromItem(item){
    if(item.handle) return item.handle;
    if(!item.url) return '';
    var match = item.url.match(/\/products\/([^?#/]+)/);
    return match ? match[1] : '';
  }

  function fetchCompleteLook(handle){
    if(!handle) return Promise.resolve([]);
    if(completeLookCache[handle]) return completeLookCache[handle];

    completeLookCache[handle] = fetch('/products/'+encodeURIComponent(handle)+'?view=complete-look',{
      credentials:'same-origin',
      headers:{'Accept':'application/json'}
    })
      .then(function(response){
        if(!response.ok) throw new Error('Complete the Look request failed');
        return response.json();
      })
      .then(function(data){ return data.products || []; })
      .catch(function(){ return []; });

    return completeLookCache[handle];
  }

  function fetchGenericFallback(seedId){
    if(!seedId) return Promise.resolve([]);
    return fetch('/recommendations/products.json?product_id='+seedId+'&limit=10')
      .then(function(response){
        if(!response.ok) throw new Error('Generic recommendations request failed');
        return response.json();
      })
      .then(function(data){ return data.products || []; })
      .catch(function(){ return []; });
  }

  function loadUpsells(cart){
    if(!upsellGrid || !upsellWrap || upsellInFlight) return;

    // Collect cart product ids + handles to exclude from recommendations
    var cartProductIds = {};
    var cartHandles = {};
    cart.items.forEach(function(item){
      cartProductIds[String(item.product_id)] = true;
      if(item.url){
        var m = item.url.match(/\/products\/([^?#/]+)/);
        if(m) cartHandles[m[1]] = true;
      }
      if(item.handle) cartHandles[item.handle] = true;
    });

    // Build a fingerprint — only re-fetch when cart product IDs change (not quantity)
    var cartKey = Object.keys(cartProductIds).sort().join(',');
    if(cartKey === lastUpsellKey) return;
    lastUpsellKey = cartKey;

    // Use the most recently added item as seed (last in cart array)
    var seedId = null;
    if(cart.items.length > 0){
      seedId = cart.items[cart.items.length - 1].product_id;
    } else {
      // Empty cart — try current page product
      var pdpEl = document.querySelector('[data-product-id]');
      if(pdpEl) seedId = Number(pdpEl.getAttribute('data-product-id'));
    }

    if(!seedId){ upsellWrap.hidden = true; return; }

    // Merge curated selections from all cart products; use recommendations only as fallback.
    upsellInFlight = true;
    var sourceItems = cart.items.slice().reverse();
    Promise.all(sourceItems.map(function(item){
      return fetchCompleteLook(productHandleFromItem(item));
    }))
      .then(function(groups){
        var curated = [];
        groups.forEach(function(products){ curated = curated.concat(products); });
        if(curated.length > 0) return curated;
        return fetchGenericFallback(seedId);
      })
      .then(function(products){
        var filtered = [];
        var seenProductIds = {};
        products.forEach(function(p){
          if(!p || !p.id) return;
          var pid = String(p.id);
          if(cartProductIds[pid]) return;
          if(p.handle && cartHandles[p.handle]) return;
          if(seenProductIds[pid]) return;
          if(p.available === false) return;
          var hasAvailable = (p.variants || []).some(function(v){ return v.available; });
          if(!hasAvailable) return;
          var rawPrice = p.price;
          if(typeof rawPrice === 'string') rawPrice = Math.round(parseFloat(rawPrice) * 100);
          p._priceCents = Number(rawPrice) || 0;
          seenProductIds[pid] = true;
          filtered.push(p);
        });

        var finalProducts = filtered.slice(0, 4);
        if(finalProducts.length === 0){ upsellWrap.hidden = true; return; }
        upsellWrap.hidden = false;
        renderUpsells(finalProducts);
      })
      .catch(function(){ upsellWrap.hidden = true; })
      .then(function(){ upsellInFlight = false; });
  }

  function renderUpsells(products){
    var html = '';
    products.forEach(function(p){
      var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/,'_240x$1$2') : '';
      var productUrl = p.handle ? ('/products/' + p.handle) : '#';

      // Build list of available variants only
      var availableVariants = (p.variants || []).filter(function(v){ return v.available; });
      if(availableVariants.length === 0) return; // skip entirely if nothing in stock

      // Deduplicate by size — only show one button per unique size label.
      // When multiple colors share the same size, we keep the first variant found.
      var seenSizes = {};
      var uniqueSizeVariants = [];
      availableVariants.forEach(function(v){
        var label = v.title || '';
        var parts = label.split(/\s*\/\s*/);
        var sizeLabel = parts[0]; // default to first option
        for(var i = 0; i < parts.length; i++){
          if(/^(XXS|XS|S|M|L|XL|XXL|2XL|3XL|4XL|5XL|\d+)$/i.test(parts[i].trim())){
            sizeLabel = parts[i].trim();
            break;
          }
        }
        var key = sizeLabel.toUpperCase();
        if(!seenSizes[key]){
          seenSizes[key] = true;
          uniqueSizeVariants.push({ id: v.id, sizeLabel: sizeLabel });
        }
      });
      if(uniqueSizeVariants.length === 0) return;

      var priceCents = p._priceCents || 0;

      html += '<div class="cd-upsell">';
      html += '  <a href="'+productUrl+'" class="cd-upsell__img">'+(img ? '<img src="'+img+'" alt="" loading="lazy">' : '')+'</a>';
      html += '  <div class="cd-upsell__body">';
      html += '    <a href="'+productUrl+'" class="cd-upsell__name">'+p.title+'</a>';
      html += '    <div class="cd-upsell__price">'+formatMoney(priceCents)+'</div>';

      // Always show size picker so customers know what size they're getting
      html += '    <button type="button" class="cd-upsell__add cd-upsell__add--pick" data-has-sizes="1">+ Add</button>';
      html += '    <div class="cd-upsell__sizes" style="display:none">';
      uniqueSizeVariants.forEach(function(sv){
        html += '<button type="button" class="cd-upsell__size-btn" data-variant-id="'+sv.id+'">'+sv.sizeLabel+'</button>';
      });
      html += '    </div>';

      html += '  </div>';
      html += '</div>';
    });
    upsellGrid.innerHTML = html;

    // Bind: "+ Add" — toggle size picker
    upsellGrid.querySelectorAll('.cd-upsell__add[data-has-sizes]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var sizesDiv = btn.nextElementSibling;
        if(!sizesDiv) return;
        var isOpen = sizesDiv.style.display !== 'none';
        // Close all other open pickers first
        upsellGrid.querySelectorAll('.cd-upsell__sizes').forEach(function(s){ s.style.display = 'none'; });
        upsellGrid.querySelectorAll('.cd-upsell__add--pick').forEach(function(b){ b.textContent = '+ Add'; });
        if(!isOpen){
          sizesDiv.style.display = 'flex';
          btn.textContent = 'Pick size ↓';
        }
      });
    });

    // Bind: individual size buttons
    upsellGrid.querySelectorAll('.cd-upsell__size-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        addUpsellVariant(btn);
      });
    });
  }

  function addUpsellVariant(btn){
    var vid = btn.getAttribute('data-variant-id');
    if(!vid || btn.disabled) return;
    var origText = btn.textContent;
    btn.textContent = '…';
    btn.disabled = true;
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:Number(vid),quantity:1}]})
    })
    .then(function(r){
      if(r.status === 429) throw new Error('rate limited');
      return r.json();
    })
    .then(function(){
      btn.textContent = 'Added ✓';
      // Hide size picker if it was open
      var sizesDiv = btn.closest('.cd-upsell__sizes');
      if(sizesDiv){
        var pickBtn = sizesDiv.previousElementSibling;
        if(pickBtn) pickBtn.textContent = 'Added ✓';
      }
      lastUpsellKey = null; // allow upsells to refresh on next render
      setTimeout(function(){
        refresh();
      }, 800);
    })
    .catch(function(){
      btn.textContent = origText;
      btn.disabled = false;
    });
  }

  /* ── Public API ── */
  window.HitchCartDrawer = {
    open: open,
    close: close,
    refresh: refresh
  };

})();
